import { create } from "@/lib/create-safe-store";

interface TypingState {
  typingUsers: Record<string, Record<string, string>>; // conversationId -> userId -> label
  setTyping: (conversationId: string, userId: string, userName?: string | null) => void;
  clearTyping: (conversationId: string, userId: string) => void;
  clearAllTyping: (conversationId: string) => void;
}

export const useTypingStore = create<TypingState>((set) => ({
  typingUsers: {},
  setTyping: (conversationId, userId, userName) =>
    set((s) => {
      const current = s.typingUsers[conversationId] || {};
      const nextName = userName || current[userId] || userId;
      if (current[userId] === nextName) return s;
      return {
        typingUsers: {
          ...s.typingUsers,
          [conversationId]: { ...current, [userId]: nextName },
        },
      };
    }),
  clearTyping: (conversationId, userId) =>
    set((s) => {
      const current = { ...(s.typingUsers[conversationId] || {}) };
      delete current[userId];
      return {
        typingUsers: {
          ...s.typingUsers,
          [conversationId]: current,
        },
      };
    }),
  clearAllTyping: (conversationId) =>
    set((s) => ({
      typingUsers: { ...s.typingUsers, [conversationId]: {} },
    })),
}));
